module.exports = __webpack_public_path__ + "img/collar edges length.adf77948.png";